import { render, staticRenderFns } from "./ExcelImporter.vue?vue&type=template&id=12b5c2f2"
import script from "./ExcelImporter.vue?vue&type=script&lang=ts"
export * from "./ExcelImporter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports